import { DataSourceType } from 'automation-ui-formula-editor/data-passing-panel/types/dataSourcesTypes';
/**
 * Determine if the provided property should be allowed based on its dataPropertyType.
 */
export const isPropertyTypeAllowListed = ({
  property,
  propertyTypeAllowList = []
}) => {
  if (!propertyTypeAllowList || propertyTypeAllowList.length <= 0) {
    return true;
  }

  // narrow down the metadata type so we can figure out what to display
  const {
    dataPropertyType
  } = property;
  if (dataPropertyType === DataSourceType.DATA_FIELDS) {
    var _property$metadata, _property$metadata2;
    const type = (_property$metadata = property.metadata) === null || _property$metadata === void 0 ? void 0 : _property$metadata.typeDefinition.type;
    const fieldType = (_property$metadata2 = property.metadata) === null || _property$metadata2 === void 0 ? void 0 : _property$metadata2.typeDefinition.fieldType;

    // Special case phone number fields. type=phone_number has more strict
    // validation than type=string, fieldType=phonenumber, but will still WAD
    // if the latter is formatted correctly. Failures are correctly reported.
    if (propertyTypeAllowList.includes('phone_number') && fieldType === 'phonenumber') {
      return true;
    }
    return propertyTypeAllowList.includes(type !== null && type !== void 0 ? type : 'unknown');
  }
  return true;
};